import { Injectable, Output, EventEmitter } from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the AuthStore provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class CompReserveListState {

  /* 表示日付 */
  private _date:Date = new Date();
  @Output() onChangeDate = new EventEmitter<Object>();
  set date(date:Date){
    this._date = date;
    this.onChangeDate.emit(this.date);
  }
  get date(){
    return this._date;
  }
}


// WEBPACK FOOTER //
// ./src/states/comp-reserve-list-state.ts